import ImgAudVideo from "../../separate/ImgAudVideo";
import Modal from 'react-bootstrap/Modal';
import { ImgValidation } from "../../actions/validations";
import { CreateCollectionFunc } from "../../actions/axioss/nft.axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import {toast} from 'react-toastify'
import { isEmpty } from "../../actions/common";
import Button from "react-bootstrap/esm/Button";
import Select from "react-select";
import useContractProviderHook from '../../actions/contractProviderHook'

export default function ImportCollection({ SetOpenPopup ,Creator ,Network ,Type ,SetFilter , Address ,GetCollection , AccountAddress }) {

const { web3 } = useSelector(state => state.LoginReducer.AccountDetails);
const { payload } = useSelector(state => state.LoginReducer.User)
const {  Categorys } = useSelector(
  (state) => state.LoginReducer);
const [BtnData, SetBtnData] = useState("start");
const [ValidateError, SetValidateError] = useState({})
const [ FormValue , SetFormValue ] = useState({
    CollectionName          :   '',
    CollectionBio           :   '',
    CollectionSymbol        :   '',
    CollectionCreator       :   Creator,
    CollectionType          :   '721',
    CollectionNetwork       :   Network,
    CollectionContractAddress : Address,
    Category            :Categorys[0].label
})
const ContractCall = useContractProviderHook();

const onChange = (e) => {
    SetBtnData("start");
    SetValidateError({})
    const { files , value , id } = e.target
    console.log("files",files)
    if(id == "CollectionSymbol") SetFormValue({...FormValue,...{[id]:value.toString().replace(/\s/g,'').toLowerCase()}})
    else SetFormValue({...FormValue , ...{[id]:value}})
}

const Validation = async (data) => {
    let ValidateError = {};
    const {
        CollectionProfileImage  ,
        CollectionName,
        CollectionSymbol,
        CollectionContractAddress,
        CollectionType
    } = data;
    if (!CollectionName) ValidateError.CollectionName = "CollectionName Required";
    if (!CollectionSymbol) ValidateError.CollectionSymbol = "CollectionSymbol Required";
    if(isEmpty(CollectionContractAddress)) ValidateError.CollectionContractAddress = "Contract Address Required";
    else{ 
      var test = await ContractCall.GetContractOwner(Number(CollectionType)==721 ? 'Single' : 'Multiple',CollectionContractAddress)
      console.log('newww testttt',test.toLowerCase(),payload.WalletAddress)
      if(test.toLowerCase() !== payload.WalletAddress){
        ValidateError.CollectionContractAddress = "Owner Address is InValid"
      }
    }
    return ValidateError;
};

const FormSubmit = async () => {
    SetBtnData("start");
    const id = toast.loading('Validating Form')
    var Error = await Validation(FormValue)
    SetBtnData('process')
    if (isEmpty(Error)) {

        let Respc = await CreateCollectionFunc(FormValue);
        console.log('rseppoonseee',Respc)
        if (Respc.success == "success") {
            SetBtnData("done");
            toast.update(id, { render: 'Collection Created Successfully', type: 'success', isLoading: false, autoClose: 1000,closeButton:true,closeOnClick:true })
            SetOpenPopup("")
            SetFilter('collection')

            }
        else {
            SetBtnData("error");
            toast.update(id, { render: Respc.data, type: 'error', isLoading: false, autoClose: 1000 ,closeButton:true,closeOnClick:true})
            if(Respc.msg === "OK"){
              SetValidateError({CollectionContractAddress: Respc.data});
            }
            else{
              SetValidateError(Respc.msg)
            }   
          }
        } else {
            SetBtnData("error");
            SetValidateError(Error);
            toast.update(id, { render: 'Check Fields', type: 'error', isLoading: false, autoClose: 1000 })
        }
    }
   



  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={true}
      className="putonsale"
    >
      <Modal.Header>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          onClick={()=>{SetOpenPopup('');SetFilter("collection")}}
        ></button>
        <Modal.Title id="contained-modal-title-vcenter">
          Import Collection
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="approvetransaction">
          <div className="gallery">
          <p className="putonsalede mt-4">Import Your Collection Here</p>
          </div>
          {ValidateError.CollectionProfileImage && (
              <div className="error_msg imagesCollection">
                {ValidateError.CollectionProfileImage}
              </div>
            )} 
          <div className={"tabbable-line"}>
            <div class="tab-content mt-5">
              <div class="tab-pane active" id="fixedprice">
                <div className="fixedpricedropdown mb-4">
                  <div className="formgroupsec text-left">
                    <label className="text-left mb-3">
                      Enter Collection Name
                    </label>
                    <div className="fixedpricedropdownflex">
                      <input
                        type="text"
                        autoComplete="off"
                        className=""
                        placeholder="Collection Name"
                        onChange={onChange}
                        id="CollectionName"
                        value={FormValue.CollectionName}
                      />

                      {ValidateError.CollectionName && (
                        <div className="error_msg">
                          {ValidateError.CollectionName}
                        </div>
                      )}
                    </div>

                    <label className="text-left mb-3">
                      Enter Collection Url
                    </label>
                    <div className="fixedpricedropdownflex">
                      <input
                        type="text"
                        autoComplete="off"
                        className=""
                        placeholder="Collection Url"
                        onChange={onChange}
                        id="CollectionSymbol"
                        value={FormValue.CollectionSymbol}
                      />

                      {ValidateError.CollectionSymbol && (
                        <div className="error_msg">
                          {ValidateError.CollectionSymbol}
                        </div>
                      )}
                    </div>
                    <div className="fixedpricedropdownflex">
                      {console.log('catttttttt',FormValue.Category)}
                    <Select
                          // value={FormValue.Category}
                          defaultValue={{label:FormValue.Category,value:FormValue.Category}} 
                          onChange={(e)=> SetFormValue({ ...FormValue, ...{ ['Category']: e.label } })}
                          options={Categorys}
                          classNamePrefix="react-select"
                          isSearchable={false}
                          />

                      {ValidateError.Category && (
                        <div className="error_msg">
                          {ValidateError.Category}
                        </div>
                      )}
                    </div>
                    

                    <label className="text-left mb-3">
                      Enter Collection Bio
                    </label>
                    <div className="fixedpricedropdownflex">
                      <input
                        type="text"
                        autoComplete="off"
                        className=""
                        placeholder="e.g.describe"
                        onChange={onChange}
                        id="CollectionBio"
                        />

                      
                    </div>
                    <label className="text-left mb-3">
                      Address
                    </label>
                    <div className="fixedpricedropdownflex">
                      <input
                        type="text"
                        autoComplete="off"
                        className=""
                        placeholder="e.g.describe"
                        onChange={onChange}
                        id="CollectionContractAddress"
                        />
                      {ValidateError.CollectionContractAddress && (
                        <div className="error_msg">
                          {ValidateError.CollectionContractAddress}
                        </div>
                      )}
                    </div>
                    <label className="text-left mb-3">
                      Type
                    </label>
                    <div className="fixedpricedropdownflex">
                      <Select
                          // value={FormValue.Category}
                          defaultValue={{label:"721",value:"721"}} 
                          onChange={(e)=> SetFormValue({ ...FormValue, ...{ ['CollectionType']: e.label } })}
                          options={[{label:"721",value:"721"},{label:"1155",value:"1155"}]}
                          classNamePrefix="react-select"
                          isSearchable={false}
                          />

                      {ValidateError.CollectionType && (
                        <div className="error_msg">
                          {ValidateError.CollectionType}
                        </div>
                      )}
                      
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
         

          <div className="connecwalletbtns mt-5 d-flex justify-content-between">
            <button className="cancelpayment primary" onClick={()=>{SetOpenPopup("");SetFilter("collection")}}>
              Cancel
            </button>
            <Button
              className="connectwallet secondary"
              onClick={BtnData == "start" ? FormSubmit : ""}
            >
              {BtnData == "start" && "Start"}
              {BtnData == "error" && "Error"}
              {BtnData == "process" && "processing"}
              {BtnData == "done" && "Done"}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
